import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from 'reactstrap';
import {
  assignAta,
  assignObiToBox,
  commitRearrangedEPIs,
  getEpikBoxData,
  updateAllEpisFirmware,
  updateEpisFirmware,
} from '../../../../../actions/EpikBoxes';
import GrandStream from '../../../../../containers/GrandStream/GrandStream';
import CustomModal from '../../../../CustomModal';
import BoxObi from './BoxObi';
import DraggableBoxObi from './DraggableBoxObi';
import './EpikBoxObis.css';
import ExternalAta from './ExternalAta';
import RearrangeEPIControls from './RearrangeEPIControls';
import RearrangePorts from '../../../../../containers/RearrangePorts/RearrangePorts';
import logoLoading from '../../../../../Res/logo-loading.gif';
import { getObiSystemStatus } from '../../../../../actions/EpikBoxes';
import { createPortal } from 'react-dom';
import ConfirmationModal from '../../../../ConfirmationModal';
import firmwareUpgrade from '../../../../../Res/svg/epi-update.svg';
import TooltipIcon from '../../TooltipIcon/TooltipIcon';
import utils from '../../../../../lib/utils';
import { toast } from 'react-toastify';
import EpiUtilitiesModal from './EpiUtilitiesModal';
import EpiRecModal from './EpiRec';
import { getPermissionForComponent } from '../../../../../utils/permissionsUtils';

const EpikboxObi = props => {
  const token = localStorage.getItem('jwtToken') || null;
  const [isOpen, setIsOpen] = useState(false);
  const [openArrange, setOpenArrange] = useState(false);
  const [showUrl, setShowUrl] = useState(null);
  const [selectedData, setSelectedData] = useState(null);
  const [newRearrangeList, setNewRearrangeList] = useState([]);
  const [arrangeLoading, setArrangeLoading] = useState(false);
  const dispatch = useDispatch();
  const boxDetails = useSelector(state => state.AppState.boxDetails.box);
  const [loading, setLoading] = useState(false);
  const [boxObisDetails, setBoxObisDetails] = useState([]);
  const [loadingObis, setLoadingObis] = useState(false);
  const [epiUpdateModal, setEpiUpdateModal] = useState(false);
  const [allEpiUpdateModal, setAllEpiUpdateModal] = useState(false);
  const [dcUpdatePopup, setDcUpdatePopup] = useState({ show: false, value: {} });
  const [isSystemStatusFetched, setIsSystemStatusFetched] = useState(false);
  const [isEpiUtilitiesOpen, setIsEpiUtilitiesOpen] = useState(false);
  const [openEpiRec, setOpenEpiRec] = useState(false);
  const epiUtilitiesPermission = getPermissionForComponent('epiUtilitiesPermission',props.user.permissionsGroup);
  const epiFirmwareUpdate = getPermissionForComponent('epiFirmwareUpdate',props.user.permissionsGroup)
  const modifyEPIS = getPermissionForComponent('modifyEPIS',props.user.permissionsGroup);
  const deleteEpiPermission = getPermissionForComponent('deleteEpi', props.user.permissionsGroup);
  const {
    obis,
    openUnassignedObis,
    showBoxConfig,
    onSelect,
    selected,
    onSetRearrange,
    onCancelRearrange,
    rearrangeState,
    rearrangedEpis,
    updateEPIs,
    onBoxEpiDelete,
    enableBoxEdit,
    obiReboot,
    box,
    user,
  } = props;
  const isAllEscene = useMemo(() => {
    return obis.some(obi => obi?.macAddress?.startsWith('0026'));
  }, [obis]);

  const timer = useMemo(() => {
    return utils.calculateEpiFirmwareUpdateTimer(boxDetails?.epiFirmwareUpdateTimer);
  }, [boxDetails?.epiFirmwareUpdateTimer]);

  const moveEpi = useCallback(
    (dragIndex, hoverIndex) => {
      const updatedEPIs = move(rearrangedEpis, dragIndex, hoverIndex);
      onSetRearrange(updatedEPIs);
    },
    [rearrangedEpis],
  );

  const checkIfEPIsAvailable = () => {

    let allowedEpis = 0
    if ((boxDetails.serialNumber.search('E') >= 0) && (boxDetails?.slaveBoxes?.length > 0)) {
      allowedEpis = utils.getAllowedEPIs(boxDetails?.slaveBoxes?.[0]?.model, true);
    }
    else {
      allowedEpis = utils.getAllowedEPIs(boxDetails?.model, false);
    }

    console.log('checkIfEPIsAvailable', boxDetails?.model, boxDetails?.Obis?.length, allowedEpis);
    if (allowedEpis > boxDetails?.Obis?.length || boxDetails?.Obis?.length == 0) {
      console.log('you are allowed to add more EPIs');

      openUnassignedObis();
      return;
    }

    toast.error(`The maximum allowed number of EPI's has been reached for this model`);
  }

  //get data from obis
  useEffect(() => {
    async function fetchData() {
      const checkBox = !boxDetails?.serialNumber?.startsWith('E-')
      setLoadingObis(false); // Start the loading state
      const initialObis = obis.map(obi => ({
        obi,
        portObiSystemStatus: null,
        isPlaceholder: checkBox,    
      }));
      setBoxObisDetails(initialObis);
      const ports = obis
        ?.map(obi => obi.port1?.boxPortNumber?.split(' ')[1])
        .filter(port => port !== null); 
      if (ports.length > 0 && checkBox) {
        try {
          const response = await dispatch(getObiSystemStatus(token, boxDetails._id, ports.join(',')));
          let res = response.portObiSystemStatus; // Assume this returns an array of results for all ports
          if (!Array.isArray(res)) {
            res = [res]; 
          }
          res.forEach(result => {
            const port = result.port; // Find the port from the result
            const indexToUpdate = obis.findIndex(obi => obi.port1?.boxPortNumber?.split(' ')[1] === port);
            if (indexToUpdate !== -1) {
              setBoxObisDetails(prevObis => {
                const updatedObis = [...prevObis];
                updatedObis[indexToUpdate] = {
                  ...updatedObis[indexToUpdate],
                  portObiSystemStatus: result, 
                  isPlaceholder: true,       
                };
                return updatedObis;
              });
            }
          });
        } catch (error) {
          console.error('Error fetching data for obis', error);
        }
      } else {
        console.error('No valid ports found to fetch data');
      }
      setLoadingObis(false); // End the loading state
    }
   if (!isSystemStatusFetched || obis.length !== boxObisDetails.length) {
      fetchData();
      setIsSystemStatusFetched(true);
      return;
    }
    
    // let temp = boxObisDetails.map(details => {
    //   if (details && details.obi && details.obi._id) {
    //     let _id = details.obi._id;
    //     if (_id) {
    //       const obi = obis.find(obi => obi._id === _id);
    //       return { obi };
    //     }
    //   }
    //   return details;
    // });
    // setBoxObisDetails(temp);
    let temp = boxObisDetails.map(details => {
      if (details && details.obi && details.obi._id) {
        let _id = details.obi._id;
        const updatedObi = obis.find(obi => obi._id === _id);
        if (updatedObi) {
          return { ...details, obi: updatedObi };
        }
      }
      return details;
    });
    setBoxObisDetails(temp);
  }, [obis, token, boxDetails]);


  const [selectedBoxObis, setSelectedBoxObis] = useState([]);
  useEffect(() => {
    const expansionBoxObis = box?.slaveBoxes?.[0]?.removedObis || []
    const primaryBoxObis = (obis || []).filter(el => !expansionBoxObis.includes(el._id))
    setSelectedBoxObis(primaryBoxObis)
  }, [obis, box])


  if (!obis.length) {
    return (
      <div className="noObiContainer">
        <div className="message"> EPI's have been moved to primary box {boxDetails?.masterBox?.displayName}</div>
        <div className="addObi">
          <Button
           className="btn-assign-edge mr-2"
            disabled={user.readOnly}
            onClick={ev => {
              ev.stopPropagation();
              checkIfEPIsAvailable();
            }}
            type="primary"
          >
            Assign EPI
          </Button>
          {(
            epiUtilitiesPermission === 'write' ||
            epiUtilitiesPermission === 'both'
          ) && (
              <Button
                color="primary"
                style={{ width: 'auto', marginLeft: '5px' }}
                onClick={() => setIsEpiUtilitiesOpen(true)}
                className="btn-assign-edge mr-2"
              >
                Utilities
              </Button>
            )}
        </div>

        <EpiUtilitiesModal
          isOpen={isEpiUtilitiesOpen}
          box={box}
          onConfirm={() => setIsEpiUtilitiesOpen(false)}
          onCancel={() => setIsEpiUtilitiesOpen(false)}
        />
      </div>
    );
  }

  const move = (arr, from, to) => {
    const clone = [...arr];
    Array.prototype.splice.call(clone, to, 0, Array.prototype.splice.call(clone, from, 1)[0]);
    return clone;
  };

  const onConfirm = async () => {
    setLoading(true);
    const body = {
      companyID: box.assignedTo._id,
      deviceMacAddress: selectedData.macAdress,
      numberOfPorts: selectedData.ports,
    };
    const result = await dispatch(assignAta(token, body, box._id));
    if (result) {
      setShowUrl({ url: result?.info?.provisioningUrl, macAddress: result?.macAddress });
      props.boxTrigger(true);
      toast.success('External ATA assigned successfully');
      setIsOpen(false);
      setShowUrl(null);
    }
    setLoading(false);
  };
  const selectedItems = (macAdress, ports) => {
    setSelectedData({ macAdress, ports });
  };

  const unassignBoxTrigger = () => {
    // eslint-disable-next-line react/destructuring-assignment
    props.boxTrigger(true);
  };

  const newObiArrangement = list => {
    setNewRearrangeList(list);
  };

  const onRearrange = async () => {
    const { getBoxData } = props;
    const sortedWithNew = newRearrangeList.sort((a, b) => a.newPort - b.newPort);
    const obisWithNew = sortedWithNew.reduce((acc, obi) => {
      const obiObj = obis[obi.currentPort];
      return [...acc, obiObj];
    }, []);

    // get ATA's Ids of expansion
    const expansionBoxObisIds = box?.slaveBoxes?.[0]?.removedObis || [];
    // get ATA object of expansion box from obis 
    let expansionObis = obis.filter(el => expansionBoxObisIds.includes(el._id))
    // combine primary & secondary ATAs
    const combinedATAs = [...obisWithNew, ...expansionObis]

    setArrangeLoading(true);
    await dispatch(commitRearrangedEPIs(token, combinedATAs, boxDetails));
    setOpenArrange(false);
    setArrangeLoading(false);
    getBoxData();
  };
  const updateEpiFirmware = async () => {
    setEpiUpdateModal(false);
    await dispatch(updateAllEpisFirmware(token, boxDetails._id));
    await dispatch(getEpikBoxData(token, boxDetails._id));
  };

  const updateAllEpiFirmware = async () =>{
    setAllEpiUpdateModal(false);
    await dispatch(updateEpisFirmware(token, boxDetails._id));
    await dispatch(getEpikBoxData(token, boxDetails._id));
  }

  const unLockBoxButton = async () => {
    const element = document.getElementById('test-lock-icon');
    if (element) {
      // Simulate a click event
      element.click();
    } else {
      console.error('Element with id "test-lock-icon" not found.');
    }
  };
  const renderModal = () => {
    if (epiUpdateModal) {
      return createPortal(
        <ConfirmationModal
          isOpen={epiUpdateModal}
          onCancel={() => {
            setEpiUpdateModal(false);
          }}
          headerText={`All EPI's Firmware Update`}
          bodyText={`This process will take approximately 15 minutes to complete and require the ports on this device to reboot. Would you like to proceed with this update now?`}
          onConfirm={updateEpiFirmware}
        />,
        document.body, // Render the modal outside the component's DOM hierarchy
      );
    }
  };
  const renderAllEpiUpdateModal = () => {
    if (allEpiUpdateModal) {
      return createPortal(
        <ConfirmationModal
          isOpen={allEpiUpdateModal}
          onCancel={() => {
            setAllEpiUpdateModal(false);
          }}
          headerText={`EPI Firmware Update`}
          bodyText={`This process will take approximately 15 minutes to complete and require the ports on this device to reboot. Would you like to proceed with this update now?`}
          onConfirm={updateAllEpiFirmware}
        />,
        document.body, // Render the modal outside the component's DOM hierarchy
      );
    }
  };

  const isESeries = boxDetails?.serialNumber && boxDetails?.serialNumber?.startsWith('E-')

  return loadingObis || boxObisDetails.length === 0 ? (
    <div
      className="error-msg d-flex flex-column justify-content-center align-items-center"
      style={{ padding: isESeries ? 0 : '30% 0' }}
    >
      <img src={logoLoading} className="loading-logo-sm" alt="loading" />
      <p className="text-align-center">Loading, Please wait...</p>
    </div>
  ) : (
    <div className="obisContainer">
      <BoxObi
        obiReboot={obiReboot}
        enableBoxEdit={enableBoxEdit}
        selected={selected}
        onBoxEpiDelete={onBoxEpiDelete}
        onObiSelect={onSelect}
        // boxObisDetails={boxObisDetails}
        boxObisDetails={boxObisDetails.map(details => {
          return {
            ...details,
            isPlaceholder: isESeries ? false : !details.portObiSystemStatus,
          };
        })}
        setDcUpdatePopup={setDcUpdatePopup}
      />
      {box?.externalAta?.length ? <ExternalAta boxTrigger={unassignBoxTrigger} box={box} /> : null}
      <div className="epiFooter margin-epi">
        <div className="container">
          <div className="row" style={{ paddingTop: '65px' }}>
            {(modifyEPIS === 'write' || modifyEPIS === 'both' || deleteEpiPermission === 'write' || deleteEpiPermission === 'both') &&
              <div className="col-md-4 py-2">
                <Button
                 className="btn-assign-edge mr-2"
                  disabled={!enableBoxEdit || user.readOnly}
                  color="primary"
                  style={{ width: 'auto' }}
                  onClick={ev => {
                    const divElement = document.getElementById('test-time-remaining');
                    const isHidden = divElement.getAttribute('hidden') !== null;
                    if (isHidden) {
                      setDcUpdatePopup({ show: true });
                    } else {
                      ev.stopPropagation();
                      checkIfEPIsAvailable();
                    }
                  }}
                >
                  Assign EPI
                </Button>
            </div>
            }
            
            {!isESeries && (
              <div className="col-md-4 py-2">
                <Button
                className="btn-assign-edge mr-2"
                  color="primary"
                  style={{ width: 'auto' }}
                  onClick={() => {
                    const divElement = document.getElementById('test-time-remaining');
                    const isHidden = divElement.getAttribute('hidden') !== null;
                    if (isHidden) {
                      setDcUpdatePopup({ show: true });
                    } else {
                      setIsOpen(true);
                    }
                  }}
                >
                  Add External Ports
                </Button>
              </div>
            )}
            {modifyEPIS && 
              <div className="col-md-4 py-2">
              <Button
              className="btn-assign-edge mr-2"
                color="primary"
                style={{ width: 'auto' }}
                onClick={() => {
                  const divElement = document.getElementById('test-time-remaining');
                  const isHidden = divElement.getAttribute('hidden') !== null;
                  if (isHidden) {
                    setDcUpdatePopup({ show: true });
                  } else {
                    setOpenArrange(true);
                  }
                }}
              >
                Rearrange Ports
              </Button>
            </div>
            }
            {!isESeries && (
              <div className="col-md-4 py-2">
                <Button
                className="btn-assign-edge mr-2"
                  hidden={!box.inhouseProvision}
                  disabled={!enableBoxEdit}
                  color="primary"
                  style={{ width: 'auto' }}
                  onClick={ev => {
                    const divElement = document.getElementById('test-time-remaining');
                    const isHidden = divElement.getAttribute('hidden') !== null;
                    if (isHidden) {
                      setDcUpdatePopup({ show: true });
                    } else {
                      ev.stopPropagation();
                      showBoxConfig();
                    }
                  }}
                >
                  AEC
                </Button>
              </div>
            )}
            {isAllEscene && timer && !isESeries && (
              <>
                {/* <div style={{ pointerEvents: user.readOnly ? 'none' : 'auto', }}>
                <TooltipIcon
                  tipId={`updateAllEpi`}
                  onClick={() => setEpiUpdateModal(true)}
                  imgSrc={firmwareUpgrade}
                  displayData="Hard Firmware Update"
                  placement="top"
                  customClass="epi-info"
                  customStyle={{
                    position: 'relative',
                    top: '3px',
                    height: '30px',
                  }}
                />
              </div> */}
                {/* <div className="col-md-4 py-2">
                  <Button
                  className="btn-assign-edge mr-2"
                    hidden={!box.inhouseProvision}
                    disabled={!enableBoxEdit}
                    color="primary"
                    style={{ width: 'auto' }}
                    onClick={ev => {
                      ev.stopPropagation();
                      setEpiUpdateModal(true);
                    }}
                  >
                    Hard Firmware Update
                  </Button>
                </div> */}
                <div className="col-md-4 py-2">
                  <Button
                  className="btn-assign-edge mr-2"
                    hidden={!box.inhouseProvision}
                    disabled={!enableBoxEdit}
                    color="primary"
                    style={{ width: 'auto' }}
                    onClick={ev => {
                      ev.stopPropagation();
                      const divElement = document.getElementById('test-time-remaining');
                      const isHidden = divElement.getAttribute('hidden') !== null;
                      if (isHidden) {
                        setDcUpdatePopup({ show: true });
                      } else {
                        setOpenEpiRec(true);
                      }
                    }}
                  >
                    EPI REC
                  </Button>
                </div>
              </>
            )}
            {isAllEscene && timer && !isESeries  && (epiFirmwareUpdate === 'write' || epiFirmwareUpdate === 'both') && (
              <div className="col-md-4 py-2">
                <Button
                className="btn-assign-edge mr-2"
                  color="primary"
                  style={{ width: 'auto' }}
                  onClick={ev => {
                    ev.stopPropagation();
                    setAllEpiUpdateModal(true);
                  }}
                >
                  Upgrade All
                </Button>
              </div>
            )}
            {(epiUtilitiesPermission === 'write' || epiUtilitiesPermission === 'both') && (
              <div className="col-md-4 py-2">
                <Button
                className="btn-assign-edge mr-2"
                  color="primary"
                  style={{ width: 'auto' }}
                  onClick={() => setIsEpiUtilitiesOpen(true)}
                >
                  Utilities
                </Button>
              </div>
            )}
          </div>
        </div>
      </div>
      <EpiRecModal
        isOpen={openEpiRec}
        onConfirm={onConfirm}
        onCancel={() => {
          setOpenEpiRec(false);
        }}
        obis={obis}
        boxDetails={boxDetails}
        user={user}
      ></EpiRecModal>
      <CustomModal
        confirmDisabled={loading || !selectedData?.macAdress || showUrl}
        header="External Port Configuration"
        onConfirm={onConfirm}
        isOpen={isOpen}
        onCancel={() => {
          setIsOpen(false);
          setShowUrl(null);
        }}
        loading={loading}
        submitDisplay={showUrl?.macAddress}
      >
        <GrandStream selectedItems={selectedItems} showUrl={showUrl} />
      </CustomModal>
      <ConfirmationModal
        bodyText={
          'You are attempting to make changes to a device that is not currently locked for editing. To prevent conflicting changes, please lock the device before proceeding.'
        }
        headerText={'Device Lock Required'}
        confirmBtnText={'Lock & Edit'}
        close={'No'}
        isOpen={dcUpdatePopup.show}
        onCancel={() => {
          setDcUpdatePopup({ show: false, value: {} });
        }}
        onConfirm={() => {
          unLockBoxButton();
          setDcUpdatePopup({ show: false, value: {} });
        }}
      />
      <CustomModal
        confirmDisabled={arrangeLoading || newRearrangeList?.length !== selectedBoxObis?.length}
        header="Rearrange Ports"
        onConfirm={onRearrange}
        isOpen={openArrange}
        onCancel={() => {
          setOpenArrange(false);
        }}
        loading={arrangeLoading}
        customButtomColor="primary"
      >
          <RearrangePorts obis={selectedBoxObis} modifyEPIS={modifyEPIS} newObiArrangement={newObiArrangement} />
      </CustomModal>
      <EpiUtilitiesModal
        isOpen={isEpiUtilitiesOpen}
        box={box}
        onConfirm={() => setIsEpiUtilitiesOpen(false)}
        onCancel={() => setIsEpiUtilitiesOpen(false)}
      />
      {renderModal()}
      {renderAllEpiUpdateModal()}
    </div>
  );
};

export default EpikboxObi;
